import React, { PropTypes } from "react";
import Modal from "../../Modal";
import Form, { FormActions, FormBody, SelectInput, SwitchInput, TextInput } from "../../Form";
import FormMultiSelectInput from "../../FormMultiSelectInput";
import { action, observable, toJS } from "mobx";
import { inject, observer } from "mobx-react";

const ProtocolList = [
  { name: "FTP", value: "FTP" },
  { name: "SFTP", value: 'SFTP' },
]

@inject("imageSourceStore", "imageSourceDeviceStore", 'idaqExportStore')
@observer
class IdaqExportModify extends React.Component {

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }
  
  @observable imageDataSource = []
  @observable id = null;

  state = {
    name: "",
    protocol: "FTP",
    host: "",
    pathname: "",
    username: "",
    password: "",
    status: "1",
    idaq_id: "0",
    idaq_id_end: null,
  }

  slug = "/export/idaq-export"

  // constructor(props){
  //   super(props)
  // }
  
  componentWillMount(){
    const { params, imageSourceDeviceStore } = this.props;
    imageSourceDeviceStore.fetchItems()

    if(params.id !== 'add') {
      this.title = "Edit Idaq Export"
      
    } else this.title = "Add Idaq Update"

  }

  componentWillUpdate(){
    const { params: { id }, idaqExportStore, imageSourceDeviceStore } = this.props;
    if(idaqExportStore.isLoading || imageSourceDeviceStore.isLoading) return;
    if(this.id !== null) return;

    if(id !== 'add' && !isNaN(+id)){
      const item = idaqExportStore.findById(id)
      // console.log(item)
      if(item){
        this.id = id;
        this.setState((prev) => ({
          ...prev,
          name: item.name,
          protocol: item.protocol,
          host: item.host,
          pathname: item.pathname,
          username: item.username,
          password: item.password,
          status: item.status,
          idaq_id: item.idaq_id,
          idaq_id_end: item.idaq_id_end
        }))

        // console.log(item.image_source_device)
        if(Array.isArray(item.image_source_device) && item.image_source_device.length > 0){
          this.imageDataSource = imageSourceDeviceStore.items.map((ii) => {
            const image_source = item.image_source_device.find((i) => +i.imagesource_device_id === +ii.id)
            return { label: `${ii.device_code} - (${ii.station_id})`, id: ii.id, value: !!image_source }
          })
          return;
        }

      }
    } 

    this.id = id;
    this.imageDataSource = imageSourceDeviceStore.items.map((ii) => {
      return { label: `${ii.device_code} - (${ii.station_id})`, id: ii.id, value: false }
    })
  }


  __inputHandler = (e, name) => {
    const { value } = e.target;
    this.setState((state) => ({ ...state, [name]: value }))
  }

  @action onOptionClicked = (item) => {
    this.imageDataSource = this.imageDataSource.map((ii) => {
      if(+ii.id === +item.id) return { ...ii, value: !item.value }
      return ii
    })
  }

  _isValidate = (payload) => {
    if(!payload.name) return { message: "Name is required" }
    if(!payload.protocol || payload.protocol === '') return { message: "Protocol is required" }
    if(!payload.host || payload.host === '') return { message: "Host is required" }
    if(!payload.pathname || payload.pathname === '') return { message: "Pathname is required" }
    if(!payload.username || payload.username === '') return { message: "Username is required" }
    if(!payload.password || payload.password === '') return { message: "Password is required" }
    if(!payload.idaq_id || payload.idaq_id === '') return { message: "Image From is required" }
    if(payload.idaq_id && isNaN(+payload.idaq_id)) return { message: "Image From must be a number" }
    if(payload.idaq_id_end && isNaN(+payload.idaq_id_end)) return { message: "Image To must be a number" }

    return null;
  }

  @action __handleSave = (e) => {
    e.preventDefault();
    const { idaqExportStore } = this.props;
    const image_source_device = this.imageDataSource.reduce((acc, item) => item.value ? [...acc, { imagesource_device_id: item.id }] : acc, [])

    const is_error = this._isValidate(this.state)
    if(is_error) return this.context.notify.error(is_error)
    const payload = { ...this.state, image_source_device }
    const promise = (this.id && !isNaN(this.id) ? idaqExportStore.updateItem({id: this.id, ...payload }) : idaqExportStore.createItem(payload))
    // modify or create
    promise.then((res) => {
        this.context.notify.success({ message: "Saved" })
        this.context.router.push(this.slug)
      })
      .catch((err) => {
        if(err instanceof Error) this.context.notify.error({ message: err.message })
        else this.context.notify.error({ message: err })
      })
  }

  render(){

    return (
      <Modal
        title={this.title}
        slug={this.slug}
        isLoading={this.props.imageSourceDeviceStore.isLoading}
        // isSaving={false}
        handleSave={this.__handleSave}
      >
        <Form>
          <FormBody>
            
            <TextInput 
              label={'Name'} 
              value={this.state.name} 
              onChange={(e) => this.__inputHandler(e, 'name')} 
            />
            <SelectInput 
              label="Protocol"
              value={this.state.protocol}
              fields={{ label: "name", value: "value" }}
              onChange={(e) => this.__inputHandler(e, 'protocol')}
              options={ProtocolList}
            />
            <TextInput 
              label={'Host'} 
              value={this.state.host} 
              onChange={(e) => this.__inputHandler(e, 'host')} 
            />
            <TextInput 
              label={'Pathname'} 
              value={this.state.pathname} 
              onChange={(e) => this.__inputHandler(e, 'pathname')} 
            />
            <TextInput 
              label={'Username'} 
              value={this.state.username} 
              onChange={(e) => this.__inputHandler(e, 'username')} 
            />
            <TextInput 
              label={'Password'} 
              value={this.state.password} 
              onChange={(e) => this.__inputHandler(e, 'password')} 
            />
            <TextInput 
              label={'Image From'} 
              value={this.state.idaq_id} 
              onChange={(e) => this.__inputHandler(e, 'idaq_id')} 
            />
            <TextInput 
              label={'Image To'} 
              value={this.state.idaq_id_end} 
              onChange={(e) => this.__inputHandler(e, 'idaq_id_end')} 
            />
            <SwitchInput 
              label={'Status'} 
              name="status"
              value={!!+this.state.status} 
              onChange={e => {
                this.setState((prev) => ({ ...prev, status: prev.status === '0' ? '1' : '0' }))
              }} 
            />

            <FormMultiSelectInput 
              id="image-data-source-multi-select"
              label="Image Data Source"
              options={toJS(this.imageDataSource)}
              optionClicked={this.onOptionClicked}
              isLoading={false}
            />

          </FormBody>

          <FormActions>
            <button onClick={this.__handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    )
  }
}

export default IdaqExportModify


// WEBPACK FOOTER //
// ./src/components/DataDelivery/IdaqExport/IdaqExportModify.js